/**
 * AddPartnerProgramCtrl controller
 * Add/edit device
 */

/**
 * AddPartnerProgramCtrl controller
 *
 * @class AddPartnerProgramCtrl
 * @memberof mwApp/partnerPrograms
 * @see mwApp/partnerPrograms
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/partnerPrograms.controller:AddPartnerProgramCtrl
 */
/* @ngInject */
export default function AddPartnerProgramCtrl ($scope, $uibModalInstance, partnerProviders, alertLiteSvc, pp) {
  var vm = this
  vm.pp = pp
  vm.isNew = pp._isNew()

  vm.partnerProviders = partnerProviders

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Save Partner Program
   *
   * @memberof mwApp/partnerPrograms.controller:AddPartnerProgramCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    pp._save()
      .then(
        () => {
          // reload catchup after create/update
          pp._update()
            .finally(
              () => {
                $uibModalInstance.close(pp)
                vm.unsetDisable()
              }
            )
        }
      ).finally(vm.unsetDisable)
  }

  /**
   * Upload logo
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return pp._uploadFile(null, file, {
      type
    }).data()
  }

  vm.uploadVertical = (file) => {
    $scope.form.$setDirty()
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 2
      const heightPart = this.height / 3
      _URL.revokeObjectURL(objectUrl)

      if (this.width < 355 || this.height < 200) {
        alertLiteSvc.alertError('Size of the logo image is less than required')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Vertical Poster aspect ratio must be 2:3')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'partner_program_vertical')
        .then((url) => {
          vm.pp.verticalImageUrl = url
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  vm.clearVertical = function () {
    $scope.form.$setDirty()
    vm.pp.verticalImageUrl = null
  }

  vm.uploadHorizontal = (file) => {
    $scope.form.$setDirty()
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 16
      const heightPart = this.height / 9
      _URL.revokeObjectURL(objectUrl)

      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Horizontal Poster aspect ratio must be 16:9')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'partner_program_horizontal')
        .then((url) => {
          vm.pp.coverImageUrl = url
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }
  vm.clearHorizontal = function () {
    $scope.form.$setDirty()
    vm.pp.coverImageUrl = null
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/partnerPrograms.controller:AddPartnerProgramsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
